import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { LightBulbIcon } from 'src/icons/light-bulb-icon';

interface Props {
  children: ReactNode;
}

export const HintBox = ({ children }: Props) => {
  return (
    <Box
      sx={{
        px: 3,
        py: 2,
        mb: 4,
        border: '1px dashed #D69D61',
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
      }}>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'start',
          justifyContent: 'center',
        }}>
        <LightBulbIcon />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {children}
      </Box>
    </Box>
  );
};
